<style scoped>
    .datatable-td {
        padding: 15px !important;
    }
</style>

<template>
    <div>
        <!-- <div class="content-wrapper"> -->
            <div class="row">
                <div class="col-sm-12 col-md-6">

                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-5">
                        <button 
                            @click="openModalAdd"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_currency') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-12 p-3 m-3">
                <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
            </div>
        <!-- </div> -->

        <AddCurrency 
            :key="modalKey"
            :currency_id="this.currency_id"
            :is_view="this.is_view"
            :is_edit="this.is_edit"
            v-if="addCurrency"
            @close="addCurrency = false"
            @save="handleSave" 
            @update="handleUpdate"
        />

        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" 
        />
    </div>
</template>

<script>
import configTable from "./mixins/configTable.js";
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { table } from './mixins/table.js';
import AddCurrency from "./AddCurrency.vue";
import { update_currency, delete_currency } from "./api/api.js";

export default {
    extends: CoreLibrary,
    mixins: [table, FormMixin],
    components :{
        AddCurrency
    },  
    data() {
        return {
            modalKey: 0,
            addCurrency : false,
            is_view : false,
            is_edit : false,
            currency_id : null,
            tableId: 'advance-table',
            options: configTable,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            rowData: {},
        }
    },
    
    created() {
        this.options.columns = this.tableColumns;
    },

    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            else if (actionObj.title == 'view') {
                const rowId = rowData.Id; 
                this.currency_id = rowId;
                this.addCurrency = true;
                this.is_view = true;
            }
            else if (actionObj.title === 'Edit') {    
                const rowId = rowData.Id; 
                this.currency_id = rowId;
                this.is_view = false;
                this.is_edit = true;
                this.addCurrency = true;
            }
        },  

        async openModalAdd(){
            this.modalKey++;
            this.currency_id = null;
            this.is_view = false;
            await this.$nextTick();
            this. addCurrency = true; 
            this.list = false;
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
        },

        async confirmed() {
            const id = this.rowData.Id;
            const res = await delete_currency(id);
            $("#demo-delete").modal('hide');
            this.cancelled();
            if (res.data.message === 'Unit successfully removed') {
                this.$hub.$emit('reload-' + this.tableId);
                this.$toastr.s(res.data.message);
                return;
            }
            this.$toastr.w(res.data.message);
        },

        openEditModal() {
            this.editDetail = true;
        },

        async handleSave(inputs) {
      		this.preloader = true;
			try {
				const response = await axios.post("/currencyResources",inputs);
				this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
                this.addCurrency = false;
			} catch (error) {
				let msg = "Error saving data";
				if (error.response.data?.error) {
				    msg = error.response.data.error;
				}
				console.log(msg, error);
				this.$toastr.e(msg);
			}
			this.preloader = false;
		},

        async handleUpdate(inputs) {
            const response = await update_currency(inputs);
            const message = response.data.message;
            const status = response.data.status;
            if (status) {
                this.$toastr.s(message); 
            }else {
                this.$toastr.e('Error');
            }
            this.$hub.$emit('reload-' + this.tableId);
            this.preloader = false;
            this.addCurrency = false;
            this.is_edit = false;
        }
    },
}
    
</script>

